module.exports = __webpack_public_path__ + "img/7774b27.png";